import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IKasaDetay_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IKasaDetay_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GoBack: any;
  GoBack_dummy: any;
  Boss_VCashDetail: any[];
  Boss_VCashDetail_dummy: any[];
  Boss_VCashDetailTotal: any[];
  Boss_VCashDetailTotal_dummy: any[];
  SetValueOf: any;
  SetValueOf_dummy: any;
}

export class KasaDetay_ScreenBase extends React.PureComponent<
  IKasaDetay_ScreenProps,
  any
> {
  kasadetay_754090_value_kuikaSelectBoxRef: React.RefObject<any>;
  kasadetay_271925_value_kuikaTableRef: React.RefObject<any>;
  kasadetay_762814_value_kuikaPaginationRef: React.RefObject<any>;
  ml = [
    {
      Id: "10a0db45-eac7-4ffc-8246-041db2ced344",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "1a964a58-169f-4ab4-a15b-efd75036975d",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 211193, PropertyName: "value", Value: "Kasa Detay" },
        { Id: 98513, PropertyName: "value", Value: "Para Birimi" },
        { Id: 190919, PropertyName: "value", Value: "Net Varlık" },
        { Id: 754090, PropertyName: "placeholder", Value: "Zaman Aralığı" },
        {
          Id: 271925,
          PropertyName: "nodatafoundmessage",
          Value: "Veri Bulunamadı",
        },
        { Id: 535927, PropertyName: "title", Value: "Title" },
        { Id: 436709, PropertyName: "value", Value: "[datafield:gun]" },
        { Id: 292787, PropertyName: "value", Value: "[datafield:ay]" },
        { Id: 794537, PropertyName: "value", Value: "[datafield:yil]" },
        { Id: 51600, PropertyName: "value", Value: "[datafield:belgetipi]" },
        { Id: 184037, PropertyName: "value", Value: "[datafield:belgeno]" },
        { Id: 522841, PropertyName: "value", Value: "[datafield:tutar]" },
        { Id: 557518, PropertyName: "value", Value: "[datafield:aciklama]" },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  constructor(props) {
    super(props);
    this.kasadetay_754090_value_kuikaSelectBoxRef = React.createRef();
    this.kasadetay_271925_value_kuikaTableRef = React.createRef();
    this.kasadetay_762814_value_kuikaPaginationRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GoBack: "",
      Boss_VCashDetail: [],
      Boss_VCashDetailTotal: [],
      SetValueOf: "",
      dataSource_754090: [
        { key: "1", text: "Bu Gün" },
        { key: "2 ", text: "Son 7 Gün" },
        { key: "3", text: "Son 1 Ay" },
        { key: "4", text: "Son 3 Ay" },
        { key: "5", text: "Son 6 Ay" },
        { key: "6", text: "Son 1 Yıl" },
        { key: "7", text: "Tüm Tarihler" },
      ],
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("kasadetay", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.KasaDetayPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("kasadetay", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("kasadetay", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.KasaDetayPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  KasaDetayPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      DateFilter_0: ReactSystemFunctions.convertToTypeByName(3, "number"),
      CustomerCode_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CustomerCode ??
          this.props.screenInputs.customercode,
        "string"
      ),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
      DateFilter_1: ReactSystemFunctions.convertToTypeByName(3, "number"),
      CustomerCode_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CustomerCode ??
          this.props.screenInputs.customercode,
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "KasaDetay/KasaDetayPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Boss_VCashDetail = result?.data.boss_VCashDetail;

    stateVars.Boss_VCashDetailTotal = result?.data.boss_VCashDetailTotal;
    formVars.kasadetay_319076_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VCashDetailTotal !== undefined
        ? stateVars.Boss_VCashDetailTotal?.length > 0
          ? stateVars.Boss_VCashDetailTotal[0].currencyCode
          : null
        : this.state.Boss_VCashDetailTotal?.length > 0
        ? this.state.Boss_VCashDetailTotal[0].currencyCode
        : null
    );
    formVars.kasadetay_413616_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VCashDetailTotal !== undefined
        ? stateVars.Boss_VCashDetailTotal?.length > 0
          ? stateVars.Boss_VCashDetailTotal[0].tutar
          : null
        : this.state.Boss_VCashDetailTotal?.length > 0
        ? this.state.Boss_VCashDetailTotal[0].tutar
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.KasaDetayPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  KasaDetayPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.kasadetay_319076_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VCashDetailTotal !== undefined
        ? stateVars.Boss_VCashDetailTotal?.length > 0
          ? stateVars.Boss_VCashDetailTotal[0].currencyCode
          : null
        : this.state.Boss_VCashDetailTotal?.length > 0
        ? this.state.Boss_VCashDetailTotal[0].currencyCode
        : null
    );

    formVars.kasadetay_413616_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VCashDetailTotal !== undefined
        ? stateVars.Boss_VCashDetailTotal?.length > 0
          ? stateVars.Boss_VCashDetailTotal[0].tutar
          : null
        : this.state.Boss_VCashDetailTotal?.length > 0
        ? this.state.Boss_VCashDetailTotal[0].tutar
        : null
    );

    stateVars.dataSource_271925 =
      stateVars.Boss_VCashDetail ?? this.state.Boss_VCashDetail;
    formVars.kasadetay_762814_total = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VCashDetail !== undefined
        ? stateVars.Boss_VCashDetail?.length > 0
          ? stateVars.Boss_VCashDetail[0].totalCount
          : null
        : this.state.Boss_VCashDetail?.length > 0
        ? this.state.Boss_VCashDetail[0].totalCount
        : null
    );
    formVars.kasadetay_762814_pageSize = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VCashDetail !== undefined
        ? stateVars.Boss_VCashDetail?.length > 0
          ? stateVars.Boss_VCashDetail[0].pageCount
          : null
        : this.state.Boss_VCashDetail?.length > 0
        ? this.state.Boss_VCashDetail[0].pageCount
        : null
    );

    formVars.kasadetay_762814_total = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VCashDetail !== undefined
        ? stateVars.Boss_VCashDetail?.length > 0
          ? stateVars.Boss_VCashDetail[0].totalCount
          : null
        : this.state.Boss_VCashDetail?.length > 0
        ? this.state.Boss_VCashDetail[0].totalCount
        : null
    );
    formVars.kasadetay_762814_pageSize = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VCashDetail !== undefined
        ? stateVars.Boss_VCashDetail?.length > 0
          ? stateVars.Boss_VCashDetail[0].pageCount
          : null
        : this.state.Boss_VCashDetail?.length > 0
        ? this.state.Boss_VCashDetail[0].pageCount
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  KasaDetayComponent_544809_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, null);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  KasaDetayComponent_754090_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      DateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "kasadetay_754090_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      CustomerCode_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CustomerCode ??
          this.props.screenInputs.customercode,
        "string"
      ),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "KasaDetay/KasaDetayComponent_754090_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Boss_VCashDetail = result?.data.boss_VCashDetail;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.KasaDetayComponent_754090_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  KasaDetayComponent_754090_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "kasadetay_762814_value",
        "string"
      ),
      1,
      ReactSystemFunctions.convertToTypeByName("current", "string"),
      false
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.KasaDetayComponent_754090_onChange2_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  KasaDetayComponent_754090_onChange2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      DateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "kasadetay_754090_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      CustomerCode_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CustomerCode ??
          this.props.screenInputs.customercode,
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "KasaDetay/KasaDetayComponent_754090_onChange2_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Boss_VCashDetailTotal = result?.data.boss_VCashDetailTotal;
    formVars.kasadetay_319076_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VCashDetailTotal !== undefined
        ? stateVars.Boss_VCashDetailTotal?.length > 0
          ? stateVars.Boss_VCashDetailTotal[0].currencyCode
          : null
        : this.state.Boss_VCashDetailTotal?.length > 0
        ? this.state.Boss_VCashDetailTotal[0].currencyCode
        : null
    );
    formVars.kasadetay_413616_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VCashDetailTotal !== undefined
        ? stateVars.Boss_VCashDetailTotal?.length > 0
          ? stateVars.Boss_VCashDetailTotal[0].tutar
          : null
        : this.state.Boss_VCashDetailTotal?.length > 0
        ? this.state.Boss_VCashDetailTotal[0].tutar
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.KasaDetayComponent_754090_onChange3_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  KasaDetayComponent_754090_onChange3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.kasadetay_319076_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VCashDetailTotal !== undefined
        ? stateVars.Boss_VCashDetailTotal?.length > 0
          ? stateVars.Boss_VCashDetailTotal[0].currencyCode
          : null
        : this.state.Boss_VCashDetailTotal?.length > 0
        ? this.state.Boss_VCashDetailTotal[0].currencyCode
        : null
    );

    formVars.kasadetay_413616_value = ReactSystemFunctions.toString(
      this,
      stateVars.Boss_VCashDetailTotal !== undefined
        ? stateVars.Boss_VCashDetailTotal?.length > 0
          ? stateVars.Boss_VCashDetailTotal[0].tutar
          : null
        : this.state.Boss_VCashDetailTotal?.length > 0
        ? this.state.Boss_VCashDetailTotal[0].tutar
        : null
    );

    stateVars.dataSource_271925 =
      stateVars.Boss_VCashDetail ?? this.state.Boss_VCashDetail;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  KasaDetayComponent_762814_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      DateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "kasadetay_754090_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      CustomerCode_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CustomerCode ??
          this.props.screenInputs.customercode,
        "string"
      ),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "kasadetay_762814_value",
            "current",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "KasaDetay/KasaDetayComponent_762814_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Boss_VCashDetail = result?.data.boss_VCashDetail;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.KasaDetayComponent_762814_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  KasaDetayComponent_762814_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_271925 =
      stateVars.Boss_VCashDetail ?? this.state.Boss_VCashDetail;
    formVars.kasadetay_762814_total = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VCashDetail !== undefined
        ? stateVars.Boss_VCashDetail?.length > 0
          ? stateVars.Boss_VCashDetail[0].totalCount
          : null
        : this.state.Boss_VCashDetail?.length > 0
        ? this.state.Boss_VCashDetail[0].totalCount
        : null
    );
    formVars.kasadetay_762814_pageSize = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VCashDetail !== undefined
        ? stateVars.Boss_VCashDetail?.length > 0
          ? stateVars.Boss_VCashDetail[0].pageCount
          : null
        : this.state.Boss_VCashDetail?.length > 0
        ? this.state.Boss_VCashDetail[0].pageCount
        : null
    );

    formVars.kasadetay_762814_total = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VCashDetail !== undefined
        ? stateVars.Boss_VCashDetail?.length > 0
          ? stateVars.Boss_VCashDetail[0].totalCount
          : null
        : this.state.Boss_VCashDetail?.length > 0
        ? this.state.Boss_VCashDetail[0].totalCount
        : null
    );
    formVars.kasadetay_762814_pageSize = ReactSystemFunctions.value(
      this,
      stateVars.Boss_VCashDetail !== undefined
        ? stateVars.Boss_VCashDetail?.length > 0
          ? stateVars.Boss_VCashDetail[0].pageCount
          : null
        : this.state.Boss_VCashDetail?.length > 0
        ? this.state.Boss_VCashDetail[0].pageCount
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.KasaDetayPageInit();
    }
  }
}
